export default "__VITE_ASSET__QeU5LHgb__"